import { useEffect } from 'react';
import { messages } from 'i18n';
import { TeamInsuranceProduct } from 'types';
import useProductFilter from './useProductFilter';

interface useIsAdmittedFilterProps {
  teamProducts: TeamInsuranceProduct[];
  teamProductsLoaded: boolean;
  paginationReset: () => void;
}

const isAdmittedFilterOptions = [
  messages.addProductsPage.additionalFilters.isAdmitted.admitted,
  messages.addProductsPage.additionalFilters.isAdmitted.nonAdmitted,
];

export function useIsAdmittedFilter({ teamProducts, teamProductsLoaded, paginationReset }: useIsAdmittedFilterProps) {
  const isAdmittedFilter = useProductFilter({
    baseFiltersList: [],
    paginationReset,
  });

  const setIsAdmittedFilters = isAdmittedFilter.setFilters;

  useEffect(() => {
    if (!teamProductsLoaded || teamProducts.length === 0) {
      return;
    }

    const isAdmittedFilterSetter = (isAdmittedList: string[]) => {
      setIsAdmittedFilters((prev) =>
        isAdmittedList.map((label) => ({
          key: label,
          checked: prev.find((item) => item.key === label)?.checked ?? false,
          label,
        })),
      );
    };

    isAdmittedFilterSetter(isAdmittedFilterOptions);
  }, [teamProductsLoaded, teamProducts, setIsAdmittedFilters]);

  return isAdmittedFilter;
}
